type AppointmentsTab = 'upcoming' | 'history';

interface AppointmentsTabsProps {
  activeTab: AppointmentsTab;
  upcomingCount: number;
  historyCount: number;
  onTabChange: (tab: AppointmentsTab) => void;
}

export const AppointmentsTabs = ({
  activeTab,
  upcomingCount,
  historyCount,
  onTabChange,
}: AppointmentsTabsProps) => (
  <div role="tablist" className="flex items-center gap-6 border-b border-gray-200">
    <button
      role="tab"
      aria-selected={activeTab === 'upcoming'}
      onClick={() => onTabChange('upcoming')}
      className={`text-sm font-semibold pb-3 border-b-2 transition-colors ${
        activeTab === 'upcoming'
          ? 'text-secondary-900 border-secondary-900'
          : 'text-secondary-400 border-transparent hover:text-secondary-600'
      }`}
    >
      Upcoming{upcomingCount > 0 && ` (${upcomingCount})`}
    </button>
    <button
      role="tab"
      aria-selected={activeTab === 'history'}
      onClick={() => onTabChange('history')}
      className={`text-sm font-semibold pb-3 border-b-2 transition-colors ${
        activeTab === 'history'
          ? 'text-secondary-900 border-secondary-900'
          : 'text-secondary-400 border-transparent hover:text-secondary-600'
      }`}
    >
      History{historyCount > 0 && ` (${historyCount})`}
    </button>
  </div>
);
